import { useCallback, useMemo } from 'react';

import { isNavigatorShareSupported } from './isNavigatorShareSupported';

export const useNativeSharing = (title: string) => {
  const share = useCallback(() => {
    window.navigator.share({
      url: window.location.href,
      title,
    });
  }, [title]);

  return useMemo(
    () => ({
      isEnabled: isNavigatorShareSupported(),
      share,
    }),
    [share],
  );
};
